import { AppRoutes } from "@/routes/config";

export type TCompanyMenu = {
  title: string;
  url: string;
  extraUrls: string[];
};

export const getCompanyMenu = (count?: {
  during_contract?: number;
  canceled_contract?: number;
  trial?: number;
  trial_cancelled?: number;
}): TCompanyMenu[] => [
  {
    title: `契約中 (${count?.during_contract ?? 0})`,
    url: AppRoutes.companyDuringContractList,
    extraUrls: [],
  },
  {
    title: `解約済み (${count?.canceled_contract ?? 0})`,
    url: AppRoutes.companyCanceledContractList,
    extraUrls: [],
  },
  {
    title: `トライアル中 (${count?.trial ?? 0})`,
    url: AppRoutes.companyTrialList,
    extraUrls: [],
  },
  {
    title: `トライアル終了 (${count?.trial_cancelled ?? 0})`,
    url: AppRoutes.companyTrialCancelledList,
    extraUrls: [],
  },
];
